<template>
    <div class="bars" :class="[!comparador ? 'simples' : 'comparador', !linhas ? '' : 'linhas']" v-if="items">
        <div v-if="comparador" class="dotted"/>
        <ul>
            <li v-for="(item, index) in items" :key="index" :style="!items || (comparador && linhas) ? null : {
                width: `calc(${percentage(Math.round(99 / items.length), 0)} - 1rem)`
            }">
                <template v-if="!comparador">
                    <span class="title full-left">{{item.opcao}} {{ !item.note ? '' : ' *' }}</span>
                    <span class="percentage">
                        <span class="bar" :style="{ backgroundColor: item.bg, height: percentage(item.value, 0) }">
                            <span class="eleitos">{{item.mandatos}}<icon name="person"/></span>
                            <span class="value">{{percentage(item.value)}}</span>
                        </span>
                    </span>
                </template>
                <template v-else>
                    <div class="info">{{item.info}}</div>
                    <div class="graph">
                        <div class="info-total">
							<span>{{item.value}}</span>
                           <icon class="icon person" name="person"/>
						</div>
                        <div class="parties">
                            <div 
                                v-for="(subitem, subindex) in (!linhas ? item.items : ([...item.items].reverse()))" 
                                :key="`${index}-${subindex}`"
                                :style="{ 
                                    backgroundColor: subitem.color, 
                                    [!linhas ? 'height' : 'width']: `${parseInt(!subitem.value ? 0 : ((!linhas ? 230 : 100) * subitem.value / 100), 0)}${!linhas ? 'px' : '%'}`
                                }"
                            />
                        </div>
                    </div>
                </template>
            </li>
        </ul>
    </div>
</template>
<script>
import { percentage } from '@/core/utils'
export default {
    props: {
        title: String,
        items: Array,
        comparador: Boolean,
        linhas: Boolean
    },
    methods: {
        percentage
    }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';
.bars {
	position: relative;
	margin-bottom: 2rem;
    &.simples {
        ul {
            margin-bottom: 2rem;
            position: relative;
            display: block;
            clear: both;
            li {
                position: relative;
                float: left;
                width: 100%;
                margin: 0 0.5rem 3.25rem;
                .percentage {
                    display: block;
                    position: relative;
                    clear: both;
                    border-radius: 2px;
                    margin-bottom: 0.25rem;
                    color: var(--base-tab-active-color);
                    font-size: .8rem;
                    height: 82px;
                    .bar {
                        position: absolute;
                        right: 0;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        background: var(--base-light-alternative-color);
                    }
                }
                .eleitos {
                    display: block;
                    color: var(--color-text);
                    font-weight: 500;
                    margin-top: -1.25rem;

                    svg {
                        width: 16px;
                        height: 16px;
                        vertical-align: text-bottom;
						opacity: 0.75;
						fill:var(--text-color);
                    }
                }
                @include medium() {
                    .eleitos {
                        font-size: 0.7rem;
                    }
                }
                @include large() {
                    .eleitos{
                        font-size: 0.8rem;
                    }
                }
                .value {
                    font-weight: 600;
                    display: block;
                    color: var(--text-color);
                    margin-top: -2.75rem;
                    text-shadow: none;
                }
                span {
                    text-align: center;
                    &.title {
                        position: absolute;
                        top: 90px;
                        left: 0;
                        right: 0;
                        overflow: hidden;
                        font-size: 12px;
                    }
                }
            }
		}
        @include medium(true) {
            ul {
                overflow-x:scroll;
                white-space: nowrap;
                padding-top: 0;
                width: calc(100% + 2rem);
                li {
                    width: 60px!important;
                    float: none;
                    display:inline-block;
                }
            }
        }
    }
    &.comparador {
        .dotted {
            height: 1px;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 113px;
            border-bottom: 2px dotted var(--base-light-alternative-color);
            pointer-events: none;
            z-index: 3;
        }
        ul {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(25px, 1fr));
            grid-gap: 1rem;
            li {
                height: 230px;
                position: relative;
                > * {
                    height: inherit;
                }
                .info {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    pointer-events: none;
                    width: 230px;
                    font-size: 0.8rem;
                    transform: rotate(-90deg);
                }
                .graph {
                    position: relative;
                    width: 28px;
                    margin-left: 24px;
                    background: var(--base-bar-color);
                    font-size: 0.75rem;
                    text-align: center;
                    overflow: hidden;
                    @include radius(3px);
                    span {
                        padding-top: 0.25rem;
                        display: block;
						color:var(--base-dark-color);
						font-weight: 600;
                    }
                    svg {
                        width: 16px;
                        height: 16px;
                        opacity: 0.5;
                    }
                    .parties {
                        position: absolute;
                        right: 0;
                        left: 0;
                        bottom: 0;
                    }
                }
            }
        }
        &.linhas {
            .dotted {
                border-bottom: none;
                width: 1px;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 50%;
                right: initial;
                height: 100%;
                border-left: 2px dotted var(--base-light-alternative-color);
                pointer-events: none;
                z-index: 3;
            }
            ul {
                display: block;
                height: auto;
                li {
                    height: auto;
                    > * {
                        position: relative;
                        top: initial;
                        right: initial;
                        bottom: initial;
                        left: initial;
                        margin-left: 0;
                        width: 100%;
                        height: 20px;
						line-height: 20px;
						margin-bottom: 0.75rem;
                        @include transform(none);
                    }
                    .info {
						line-height: 45px;
                    }
                    .graph {
                        > * {
                            position: absolute;
                            top: 0;
                            bottom: 0;
                        }
                        .info-total{
							position: absolute;
                            top: 0;
                            bottom: 0;
							right: 0.5rem;
							z-index: 2;
							span, 
                             svg {
							z-index: 2;
							display: inline;
							vertical-align: middle;
                             }
						}
                        .parties {
                            right: 0;
                            * {
                                height: 100%;
                                float: left;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
